(async()=>{
    try{

        const theme_version = document.body.dataset.themeVersion;
        const req = await fetch('https://www.myoddballs.com/pages/subscription-selector?view=nav-labels');
        const data = await req.text();
        const lists = JSON.parse(data);
        const mobileList = lists.mobile_nav.lists.find((list)=>{
        return list.theme == theme_version; 
    }).labels
    const desktopList = lists.desktop_nav.lists.find((list)=>{
        return list.theme == theme_version; 
    }).labels;
    const desktopNav = document.querySelector(".desktop-navigation");
    const desktopTopLevelItems = desktopNav.querySelectorAll('[role="menuitem"]');
    desktopTopLevelItems.forEach((item)=>{
        const matchingItem = desktopList.find((listItem)=>{
            return listItem.title_match.toLowerCase() == item.textContent.trim().toLowerCase()
        })
        if(matchingItem){
            const label=document.createElement("span");
            label.style.border = '1px solid ' + matchingItem.outline_colour;
            label.style.color = matchingItem.text_colour;
            label.innerHTML = matchingItem.text;
            label.style.backgroundColor =  matchingItem.bg_colour
            label.style.verticalAlign =  "middle";
            label.style.fontSize = "0.6rem";
            label.className = "nav-label inline pointer-events-none ml-2 rounded-full pt-1 pb-1 px-2 text-xxs uppercase font-semibold flex-shrink-0"
            item.appendChild(label)
        }
    })
    const destopSecondLevelItems = desktopNav.querySelectorAll("p")
    destopSecondLevelItems.forEach((item)=>{
        const matchingItem = desktopList.find((listItem)=>{
            return listItem.title_match.toLowerCase() == item.textContent.trim().toLowerCase()
        })
        if(matchingItem){
            const label=document.createElement("span");
            label.style.border = '1px solid ' + matchingItem.outline_colour;
            label.style.color = matchingItem.text_colour;
            label.innerHTML = matchingItem.text;
            label.style.backgroundColor =  matchingItem.bg_colour
            label.style.verticalAlign =  "middle";
            label.style.fontSize = "0.6rem";
            label.className = "nav-label inline pointer-events-none ml-2 rounded-full pt-1 pb-1 px-2 text-xxs uppercase font-semibold flex-shrink-0"
            item.appendChild(label)
        }
    })
    const destopThirdLevelItems = desktopNav.querySelectorAll("a.no-underline")
    destopThirdLevelItems.forEach((item)=>{
        const matchingItem = desktopList.find((listItem)=>{
            return listItem.title_match.toLowerCase() == item.textContent.trim().toLowerCase()
        })
        if(matchingItem){
            const label=document.createElement("span");
            label.style.border = '1px solid ' + matchingItem.outline_colour;
            label.style.color = matchingItem.text_colour;
            label.innerHTML = matchingItem.text;
            label.style.backgroundColor =  matchingItem.bg_colour
            label.style.verticalAlign =  "middle";
            label.style.fontSize = "0.6rem";
            label.className = "nav-label inline pointer-events-none ml-2 rounded-full pt-1 pb-1 px-2 text-xxs uppercase font-semibold flex-shrink-0"
            item.appendChild(label)
        }
    })
    const mobileNav = document.querySelector(".side-nav");
    const mobileTopLevelItems = mobileNav.querySelectorAll('.menu-btn');
    mobileTopLevelItems.forEach((item)=>{
        const matchingItem = mobileList.find((listItem)=>{
            return listItem.title_match.toLowerCase() == item.textContent.trim().toLowerCase()
        })
        if(matchingItem){
            const label=document.createElement("span");
            label.style.border = '1px solid ' + matchingItem.outline_colour;
            label.style.color = matchingItem.text_colour;
            label.innerHTML = matchingItem.text;
            label.style.backgroundColor =  matchingItem.bg_colour
            label.style.verticalAlign =  "middle";
            label.style.fontSize = "0.6rem";
            label.className = "nav-label inline pointer-events-none ml-2 rounded-full pt-1 pb-1 px-2 text-xxs uppercase font-semibold flex-shrink-0"
            item.appendChild(label)
        }
    })
    const mobileSecondLevelItems = mobileNav.querySelectorAll(".hs-accordion-toggle")
    mobileSecondLevelItems.forEach((item)=>{
        const matchingItem = mobileList.find((listItem)=>{
            return listItem.title_match.toLowerCase() == item.textContent.trim().toLowerCase()
        })
        if(matchingItem){
            const label=document.createElement("span");
            label.style.border = '1px solid ' + matchingItem.outline_colour;
            label.style.color = matchingItem.text_colour;
            label.innerHTML = matchingItem.text;
            label.style.backgroundColor =  matchingItem.bg_colour
            label.style.verticalAlign =  "middle";
            label.style.fontSize = "0.6rem";
            label.className = "nav-label inline pointer-events-none ml-2 rounded-full pt-1 pb-1 px-2 text-xxs uppercase font-semibold flex-shrink-0"
            item.appendChild(label)
        }
    })
    const mobileThirdLevelItems = mobileNav.querySelectorAll("p.typography")
    mobileThirdLevelItems.forEach((item)=>{
        const matchingItem = mobileList.find((listItem)=>{
            return listItem.title_match.toLowerCase() == item.textContent.trim().toLowerCase()
        })
        if(matchingItem){
            const label=document.createElement("span");
            label.style.border = '1px solid ' + matchingItem.outline_colour;
            label.style.color = matchingItem.text_colour;
            label.innerHTML = matchingItem.text;
            label.style.backgroundColor =  matchingItem.bg_colour
            label.style.verticalAlign =  "middle";
            label.style.fontSize = "0.6rem";
            label.className = "nav-label inline pointer-events-none ml-2 rounded-full pt-1 pb-1 px-2 text-xxs uppercase font-semibold flex-shrink-0"
            item.appendChild(label)
        }
    })
}catch(error){
    console.error(error)
}
})()